import { render } from "./JoinNowStep05Email.vue?vue&type=template&id=0aca2446&scoped=true"
import script from "./JoinNowStep05Email.vue?vue&type=script&lang=js"
export * from "./JoinNowStep05Email.vue?vue&type=script&lang=js"

import "./JoinNowStep05Email.vue?vue&type=style&index=0&id=0aca2446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aca2446"]])

export default __exports__